
enum OperationType {
	ALL_YEAR = 'ALL_YEAR', SEASONAL = 'SEASONAL'
}

export default OperationType;